jQuery(document).ready(function($) {

	// global js code goes here

	/**
	 * Pause youtube videos when it's containing modal window is closed
	 */ 
	$('.video-modal').on('hide.bs.modal', function (e) {
		var $this = $(this).find('iframe');
    $this[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
	});

	/**
	 * Initialize popovers if they exist, activate on click or hover, close if "x" button clicked as well
	 */
	var showPopover = function () {
    $(this).popover('show');
	};
	var hidePopover = function () {
    $(this).popover('hide');
	};
	$(function () {
	  $('.popup-container [data-toggle="popover"]').popover({
	    container: 'body',
	    trigger: 'manual',
	    placement: 'bottom',
	    html: true,
	    title: function() {
	    	// only add title with close button for smaller screen sizes
	    	if (!window.matchMedia || (window.matchMedia("(max-width: 990px)").matches)) {
	    		return $(this).parent().find('.btn-row-popup-menu-head').html();
	    	}
			},
	   	template: '<div class="popover extra-info-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body bg-light p-4"></div></div>'
	  })
  	.click(showPopover)
  	.hover(showPopover,hidePopover);
	});
	$(document).on('click', function(e) {
		$('.popup-container [data-toggle="popover"]').each(function() {
			var target = $(e.target);
			if (!target.is('.popover') && !target.is('.popover *') && !target.is('.btn-row-popup-menu') || target.is('.btn-popover-close')) {
			(($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false;
			}
		});
	});

	/**
	 * Setup image carousel and lightbox if they exist
	 */
  if ($('#image-slider').length > 0) {
		document.getElementById('image-slider').onclick = function (event) {
	    event = event || window.event;
	    var target = event.target || event.srcElement,
	      link = target.src ? target.parentNode : target,
	      options = {index: link, event: event},
	      links = this.querySelectorAll('a.carousel-thumb');
	    if (!$(target).hasClass('carousel-control') && !$(target).is("i"))
	    	blueimp.Gallery(links, options);
		};
	}
	$('#image-slider').on('slide.bs.carousel', function (e) {
    var $e = $(e.relatedTarget);
    var idx = $e.index();
    var itemsPerSlide = 4;
    var totalItems = $('.carousel-item').length;
    
    if (idx >= totalItems-(itemsPerSlide-1)) {
      var it = itemsPerSlide - (totalItems - idx);
      for (var i=0; i<it; i++) {
        // append slides to end
        if (e.direction=="left") {
          $('.carousel-item').eq(i).appendTo('.carousel-inner');
        }
        else {
          $('.carousel-item').eq(0).appendTo('.carousel-inner');
        }
      }
    }
	});


	/**
	 * Auto format donation phone number
	 */
	$('.phone-input').keyup(function(){
    $(this).val($(this).val().replace(/(\d{3})\-?(\d{3})\-?(\d{4})/,'$1-$2-$3'))
	});

	// Output a custom note to pass to Paypal with donation designation allotments/instructions
	function designationText() {
		var educationVal = $('input[name="designation0"]').val();
		var ghostVal = $('input[name="designation1"]').val();
		var developmentVal = $('input[name="designation2"]').val();
		var otherVal = $('input[name="designation3"]').val();
		var otherDescription = $('input[name="custom_designation"]').val();
		var designation_note = '';
		if (educationVal && educationVal != 0) designation_note += '$' + educationVal + ' for children\'s Lake Bluff education. ';
		if (ghostVal && ghostVal != 0) designation_note += '$' + ghostVal + ' for Ghost Walk sponsorship. ';
		if (developmentVal && developmentVal != 0) designation_note += '$' + developmentVal + ' for program development. ';
		if (otherVal && otherVal != 0) designation_note += '$' + otherVal + ' ' + otherDescription;
		return designation_note;
	}

	/**
	 * Handle donation form submission
	 */

	// When preset donation button clicked restore custom donation field to default state
	$('input[name="giveAmount"]').click(function(e){
		var $this = $(this);
		$('#paypal-form input[name="amount"]').val($this.val()); // set Paypal value
	});

	var $form = $('#paypal-form form');
	$('#paypal-form #submit-donation').click(function(){	  

  	// add a loading spinner
    $( '<div id="language-spinner" class="loading">Loading&#8230;</div>' ).insertAfter( '#wrapper-branding' );

    if ($('input[name="giveAmount"]:checked').val() == 'other') {
    	$('#paypal-form input[name="amount"]').val($('#giveCustom').val()); // set Paypal value
    }    

    // set donation $$$ designation note
    var designation_details = designationText();
    if (designation_details) {
    	$('#paypal-form input[name="on0"]').val('Designation: '); 
    	$('#paypal-form input[name="os0"]').val(designationText());
    } else {
    	$('#paypal-form input[name="on0"]').val(''); 
    	$('#paypal-form input[name="os0"]').val('');
    }

    if ($('input[name="donateFees"]:checked').val() == 'yes') {
    	var current_amount = $('#paypal-form input[name="amount"]').val();    	
    	var new_amount = Number(current_amount) + 3;
    	$('#paypal-form input[name="amount"]').val(new_amount); // set Paypal value
    }

	  $('#paypal-form #paypal-submit').click(); // trigger Paypal submission

	});

		/**
		 * Handle brick form submission
		 */

		// When preset donation button clicked restore custom donation field to default state
		$('input[name="giveAmount"]').click(function(e){
			var $this = $(this);
			$('#paypal-form-bricks input[name="amount"]').val($this.val()); // set Paypal value
		});

		var $form = $('#paypal-form-bricks form');
		$('#paypal-form-bricks #submit-donation').click(function(){	  

	  	// add a loading spinner
	    $( '<div id="language-spinner" class="loading">Loading&#8230;</div>' ).insertAfter( '#wrapper-branding' );

	    if ($('input[name="giveAmount"]:checked').val() == 'other') {
	    	$('#paypal-form-bricks input[name="amount"]').val($('#giveCustom').val()); // set Paypal value
	    }    

	    // set commemorative brick text note if necessary
	    if ($('input[name="brickToggle"]:checked').val() == 'yes') {
	    	if ($('input[name="brickrow1"]').val()) {
	    		$('#paypal-form-bricks input[name="on0"]').val('Commemorative brick line 1:');
	    		$('#paypal-form-bricks input[name="os0"]').val($('input[name="brickrow1"]').val());
	    	} else {
	    		$('#paypal-form-bricks input[name="on0"]').val('');
	    		$('#paypal-form-bricks input[name="os0"]').val('');
	    	}
	    	if ($('input[name="brickrow2"]').val()) {
		    	$('#paypal-form-bricks input[name="on1"]').val('Commemorative brick line 2:');
					$('#paypal-form-bricks input[name="os1"]').val($('input[name="brickrow2"]').val());
	    	} else {
	    		$('#paypal-form-bricks input[name="on1"]').val('');
	    		$('#paypal-form-bricks input[name="os1"]').val('');
	    	}
				if ($('input[name="brickrow3"]').val()) {
					$('#paypal-form-bricks input[name="on2"]').val('Commemorative brick line 3:');
					$('#paypal-form-bricks input[name="os2"]').val($('input[name="brickrow3"]').val());
				} else {
					$('#paypal-form-bricks input[name="on2"]').val('');
					$('#paypal-form-bricks input[name="os2"]').val('');
				}
	    	
	    } else {
	    	$('#paypal-form-bricks .brick-data').val(''); // reset all Paypal brick hidden fields
	    }

	    if ($('input[name="donateFees"]:checked').val() == 'yes') {
	    	var current_amount = $('#paypal-form input[name="amount"]').val();    	
	    	var new_amount = Number(current_amount) + 3;
	    	$('#paypal-form-bricks input[name="amount"]').val(new_amount); // set Paypal value
	    }

		  $('#paypal-form-bricks #paypal-submit').click(); // trigger Paypal submission

		});

});
